<div class='mb--md'>
  <div class='pr--md'>
    <app-card-selector
      [initialSelectedCards]="currentSelectedCards"
      [defaultCards]="defaultSelectedCards"
      [allCurrentCards]='allCurrentCards'
      (preferencesSaved)="onPreferencesSaved($event)">
    </app-card-selector>
  </div>

  <ng-container *ngFor='let cardGroup of allCurrentCards'>
    <ng-container *ngIf='cardGroup.showGroup'>
      <div class='row'>
        <div class='column--12'>
          <h3>{{ cardGroup.label }}</h3>
        </div>
      </div>

      <div class='row mb--md'>
        <ng-container *ngFor='let card of cardGroup.cards'>
          <div class='column--6 column-xl--4 mt--sm with-gutter' *ngIf='currentSelectedCards.includes(card.type)'>
            <app-report-card
              [canDownloadData]='canDownloadCardData'
              [loadingData]='downloadingReportData'
              [cardInitialized]='card.isInitialized'
              [loadingCard]="card.isLoading"
              [loadingCardFailed]="card.loadingFailed"
              [iconClass]="card.iconClass"
              [titleClass]="card.titleClass"
              [cardTitle]="card.title"
              [totalStat]="card.total"
              [isCurrency]="card.isCurrency"
              [subStatsTemplate]="card.subStatTemplate"
              [subStatsContext]='card.subStatsContext ? card.subStatsContext : undefined'
              (refresh)="refreshReportCard(card)"
              (downloadData)='downloadCardData(card.type)'
            ></app-report-card>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <!--  Sub Stats Output Templates-->
  <ng-template #accountSubStats let-context>(Active accounts: {{context.accountsWithOne}})</ng-template>
  <ng-template #revenueSubStats let-context>
    (BYOA: {{(context.byoaRevenue | currency : 'CAD' : 'symbol-narrow')}},
    MA: {{(context.maRevenue | currency : 'CAD' : 'symbol-narrow')}})
  </ng-template>
  <ng-template #greenSubStats let-context>(Number of shipments: {{context.greenShipments}})</ng-template>
  <ng-template #reconSubStats let-context>
    (Stripe: {{context.stripeReconAdjustment | currency : 'CAD' : 'symbol-narrow'}},
    Machool billing: {{context.maReconAdjustment | currency : 'CAD' : 'symbol-narrow'}})
  </ng-template>
  <ng-template #maOnlyRevenueSubStats let-context>
    (MA: {{(context.maRevenue | currency : 'CAD' : 'symbol-narrow')}})
  </ng-template>
  <ng-template #signeLocalSubStats let-context>
    (Machool Fee: {{(context.machoolFee | currency : 'CAD' : 'symbol-narrow')}})
  </ng-template>
  <ng-template #commissionSubStats let-context>
    Commission: {{(context.commissionAmount | currency : 'CAD' : 'symbol-narrow')}}
  </ng-template>
  <ng-template #walletSubStats let-context>
    (Accounts with active wallet: {{ context.totalWalletAccounts }})
  </ng-template>
  <ng-template #numShipmentsSubStats let-context>(Number of shipments: {{context.totalByoaShipments}})</ng-template>
  <ng-template #shipmentsSubStats let-context>
    (BYOA: {{context.byoaShipments}}, MA: {{context.maShipments}})
  </ng-template>
  <ng-template #loyaltyRewardsSubStats let-context>
    (Pending: {{(context.totalPendingRewards  | currency : 'CAD' : 'symbol-narrow')}}, Not claimed: {{(context.totalAvailableRewards  | currency : 'CAD' : 'symbol-narrow')}})
  </ng-template>
</div>
